import React from "react";
import styles from "./styles.module.css";
import { getRegExp, getSentenceFromCamelCase } from "./Helpers";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import { InputProps } from "../../types/form";

const PasswordInput = ({
  checked,
  className,
  disabled,
  error,
  fixLength,
  required,
  label,
  minLength,
  maxLength,
  name,
  onChange,
  placeholder,
  reqType,
  style,
  validationHandler,
  value,
  size = "medium",
  labelClassName,
}: InputProps) => {
  const [show, setShow] = React.useState<boolean>(false);
  const mappedClassName = className && styles[className] ? styles[className] : className || "";

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    const inputValue = type === "checkbox" ? checked : value;
    onChange && onChange(name, inputValue as any);
  };

  const onValidationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!validationHandler) return;
    const { value } = event.target;
    let errorMessage = "";

    if (!value && required) {
      errorMessage = `Please enter ${getSentenceFromCamelCase(name)}.`;
    } else if (minLength && value.length < minLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be at least ${minLength} characters long.`;
    } else if (maxLength && value.length > maxLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be ${maxLength} characters long.`;
    } else if (fixLength && value.length !== fixLength) {
      errorMessage = `${
        name.charAt(0).toUpperCase() + getSentenceFromCamelCase(name).slice(1)
      } must be ${fixLength} characters.`;
    } else if (value && reqType) {
      const regExp = getRegExp(reqType) as RegExp;
      if (!regExp.test(value)) {
        errorMessage = `Please enter valid ${getSentenceFromCamelCase(name)}.`;
      }
    }

    validationHandler(name, errorMessage);
  };

  return (
    <div className={`${styles.InputContainer} ${styles[size || "medium"]}`}>
      <div className={styles.labelRow}>
        <label htmlFor={name} className={`${styles.label} ${labelClassName || ""}`}>
          {label}
          {required && <span className={styles.required}>&nbsp;*</span>}
        </label>
        {error ? <span className={styles.errorText}>{error}</span> : null}
      </div>

      <div className={`${styles.fieldWrapper} ${styles.passwordWrapper} ${error ? styles.hasError : ""} ${disabled ? styles.disabled : ""}`}>
        <span className={styles.inputIcon}>
          <FaLock />
        </span>
        <input
          type={show ? "text" : "password"}
          name={name}
          id={name}
          value={(value as any) || ""}
          checked={checked}
          placeholder={placeholder || "Enter your password"}
          className={`${styles.inputControl} ${styles.blackBorder} ${mappedClassName}`}
          required={required}
          style={style}
          disabled={disabled}
          onChange={onChangeHandler}
          onBlur={onValidationChange}
        />
        <button
          type="button"
          className={styles.passwordToggle}
          onClick={() => setShow(!show)}
          aria-label={show ? "Hide password" : "Show password"}
        >
          {show ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
